import { useTranslation } from "react-i18next";

const HomePageBudgetFooter = () => {
    const { t } = useTranslation();

    return (
        <div className="hp-budget-footer">
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: "30px",
                }}
            >
                <div style={{ display: "flex", gap: "7px", alignItems: "baseline" }}>
                    <div className="hp-used-sum-point"></div>
                    {t("homepage.UsedSum")}
                </div>
                <div style={{ display: "flex", gap: "7px", alignItems: "baseline" }}>
                    <div className="hp-obligo-balance-point"></div>
                    {t("homepage.ObligoBalance")}
                </div>
                <div style={{ display: "flex", gap: "7px", alignItems: "baseline" }}>
                    <div className="hp-used-monthly-point"></div>
                    {t("homepage.UsedMonthly")}
                </div>
            </div>
        </div>
    );
};

export default HomePageBudgetFooter;
